angular.module 'zc.projects'

.controller 'SegmentEditCtrl', ($scope, $state, $translate, Page, CampaignSegment, Devise, currentProject, segment, titlesBySegmentType) ->
  Page.setBodyClass ''
  $translate('projectsSegments.controllers.edit.segumento_henshuu').then (translation) ->
    Page.setTitle translation

  $scope.Devise = Devise
  $scope.project = currentProject
  $scope.segment = segment
  $scope.detailsVisible = false
  CampaignSegment.toZcRule($scope.segment)

  QUERY_INTERVAL_MS = 300

  # list of parameters which user input will be ignored.
  IGNORED_PARAMETERS = [
    'name'
  ]

  # returns true if a parameter value in the list above has changed
  isIgnoredParameterChanged = (newParams, oldParams) ->
    _.some IGNORED_PARAMETERS, (param) ->
      newValue = _.get(newParams, param)
      oldValue = _.get(oldParams, param)
      not _.isEqual(newValue, oldValue)

  $scope.getPageTitle = (segment_type) ->
    return titlesBySegmentType[segment_type]

  $scope.getTemplateUrl = () ->
    type = switch $scope.segment.segment_type
      when 'custom_old'
        'custom'
      else
        $scope.segment.segment_type
    "/templates/projects.segments/campaign_segment_edit_#{type}.html"

  $scope.save = () ->
    if $scope.segment.segment_type in ['custom', 'custom_old']
      CampaignSegment.toZcRule($scope.segment)
      if $scope.segment.message
        alertify.error $translate.instant('projectsSegments.controllers.edit.invalid_format')
        return

    if $scope.segment.id
      promise = CampaignSegment.update {
        projectId: $scope.project.id
        id: $scope.segment.id
      }, {
        campaign_segment: $scope.segment
      }
    else
      promise = CampaignSegment.create {
        projectId: $scope.project.id
      }, {
        campaign_segment: $scope.segment
      }

    promise.then (res) ->
      if res.id
        alertify.success $translate.instant('projectsSegments.controllers.edit.hozon_shimashita')
        $state.go 'admin.projects.segments', { projectId: $scope.project.id }
      else
        alertify.error $translate.instant('projectsSegments.controllers.edit.hozon_ga_shippai')

  # watch deeply because we need to track all changes
  # in segment and regenerate mongo_query on server
  $scope.$watch 'segment',
    _.debounce((newObject, oldObject) ->
      return unless newObject
      return if isIgnoredParameterChanged(newObject, oldObject)

      CampaignSegment.getMongoQuery(newObject)
        .then (res) ->
          $scope.segment.mongo_query = res

    , QUERY_INTERVAL_MS)
  , true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.segments/edit.controller.coffee